import { render, staticRenderFns } from "./OtpAuthAppliedMessage.vue?vue&type=template&id=1d8bb9c3&scoped=true"
import script from "./OtpAuthAppliedMessage.vue?vue&type=script&lang=js"
export * from "./OtpAuthAppliedMessage.vue?vue&type=script&lang=js"
import style0 from "./OtpAuthAppliedMessage.vue?vue&type=style&index=0&id=1d8bb9c3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d8bb9c3",
  null
  
)

export default component.exports